/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { InputAction } from "../../../model/enums/InputAction";
import { ModalController } from "../../../model/navigation";

/** Modal name used to register/remove this controller on a screen's modal stack. */
export const INACTIVITY_OSD_MODAL_NAME: string = "INACTIVITY_OSD";

/**
 * ModalController pushed onto a screen's modal stack while the anti-burn-in
 * inactivity OSD (see `useInactivityOsd`) is displayed. Reusable across any
 * screen that adopts `useInactivityOsd` (e.g. Search, and future pages).
 *
 * `useInactivityOsd` already dismisses the OSD and restarts its own idle
 * timer on ANY input via a global NavigationEngine interceptor — that
 * mechanic is untouched here. This modal's only job is to stop the SAME
 * input that dismissed the OSD from ALSO reaching the screen's own
 * navigation/selection handling underneath, e.g.:
 *   - BACK must only dismiss the OSD, not also navigate away from the screen.
 *   - NAV_OK ("SELECT") must only dismiss the OSD, not also trigger an
 *     action on whatever was focused underneath.
 *
 * All handlers simply consume the input (return true) with no other
 * side effect — dismissal and timer bookkeeping remain entirely owned by
 * `useInactivityOsd`.
 */
export class InactivityOsdController extends ModalController {
  public constructor() {
    super(INACTIVITY_OSD_MODAL_NAME);
  }

  protected initialize(): void {
    this.registerHandler(InputAction.NAV_UP, (): boolean => true);
    this.registerHandler(InputAction.NAV_DOWN, (): boolean => true);
    this.registerHandler(InputAction.NAV_LEFT, (): boolean => true);
    this.registerHandler(InputAction.NAV_RIGHT, (): boolean => true);
    this.registerHandler(InputAction.NAV_OK, (): boolean => true);
    this.registerHandler(InputAction.BACK, (): boolean => true);
  }
}
